namespace $.$$ {

	$mol_style_define( $shm_hitalama_agent_session, {

		flex: {
			grow: 1,
			shrink: 1,
			basis: 0,
		},

		Chat_page: {
			flex: {
				basis: '56rem',
				grow: 1,
				shrink: 1,
			},
			minWidth: '34rem',
			Tools: {
				align: {
					items: 'center',
				},
				gap: $mol_gap.text,
			},
			Body: {
				overflow: 'visible',
			},
			Body_content: {
				flex: {
					grow: 1,
					shrink: 1,
					basis: 0,
				},
				height: '100%',
				maxHeight: '100%',
				padding: 0,
				paddingLeft: '0.5rem',
			},
		},

		Thinking_page: {
			flex: {
				basis: '30rem',
				grow: 1,
				shrink: 0,
			},
			Body_content: {
				flex: {
					grow: 1,
					shrink: 1,
					basis: 0,
				},
				height: '100%',
				maxHeight: '100%',
			},
		},

		Chat_tokens: {
			align: {
				items: 'center',
			},
			padding: {
				left: $mol_gap.text,
				right: $mol_gap.text,
			},
			minHeight: '2rem',
			color: $mol_theme.shade,
			font: {
				size: '0.8rem',
			},
		},

		Chat_model: {
			align: {
				items: 'center',
			},
			maxWidth: '12rem',
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis',
			color: $mol_theme.shade,
			font: {
				size: '0.75rem',
			},
		},

		Chat_backend: {
			color: $mol_theme.shade,
		},

		Send_error: {
			color: $shm_theme.error,
		},

		Chat_settings_content: {
			flexDirection: 'column',
			gap: $mol_gap.block,
			padding: {
				left: $mol_gap.block,
				right: $mol_gap.block,
				top: $mol_gap.block,
				bottom: $mol_gap.block,
			},
			minWidth: '22rem',
			maxWidth: '32rem',
		},

		View_mode: {
			flex: {
				shrink: 0,
			},
		},

		Provider_label: {
			width: '100%',
		},

		Model_label: {
			width: '100%',
		},

		Messages_box: {
			position: 'relative',
			flex: {
				grow: 1,
				shrink: 1,
				basis: 0,
			},
			minHeight: '18rem',
			minWidth: 0,
		},

		Messages: {
			flex: {
				grow: 1,
				shrink: 1,
				basis: 0,
				direction: 'column',
			},
			width: '100%',
			height: '100%',
			minHeight: 0,
			overflow: 'auto',
			gap: $mol_gap.text,
			padding: {
				right: $mol_gap.text,
				bottom: $mol_gap.block,
			},
		},

		Messages_new: {
			position: 'absolute',
			right: $mol_gap.block,
			bottom: $mol_gap.block,
			zIndex: $mol_layer.hover,
		},

		Prompt: {
			height: '7rem',
			minHeight: 0,
			overflow: 'auto',
			width: 'min-content',
			minWidth: 0,
			flex: { shrink: 1 },
			Edit: {
				position: 'relative',
			},
		},

		Send: {
			height: '1rem',
			margin: {
				right: '2.5rem',
			},
		},

		Message_row: {
			flex: {
				shrink: 0,
			},
			background: {
				color: $mol_theme.card,
			},
			'[role]': {
				user: {
					// background: {
					// 	color: 'transparent',
					// },
				},
				assistant_step: {
					// maxHeight: '20rem',
					overflow: 'scroll',
				},
			},
			padding: {
				left: $mol_gap.block,
				right: $mol_gap.block,
				top: $mol_gap.text,
				bottom: $mol_gap.block,
			},
			margin: {
				bottom: 0,
			},
			flexDirection: 'column',
			gap: $mol_gap.text,
			border: {
				radius: $mol_gap.round,
			},
		},

		Message_head: {
			color: $mol_theme.shade,
			font: {
				size: '0.8rem',
			},
			gap: $mol_gap.text,
			align: {
				items: 'center',
			},
		},

		Message_thinking: {
			minHeight: '2rem',
			margin: {
				left: $mol_gap.text,
			},
			padding: {
				top: 0,
				bottom: 0,
			},
			align: {
				items: 'center',
			},
		},

		Message_time: {
			margin: {
				left: 'auto',
			},
		},

		Message_text_box: {
			flex: {
				shrink: 0,
			},
			margin: '-0.75rem',
			minHeight: 0,
		},

		Message_question_options: {
			flex: {
				wrap: 'wrap',
			},
			gap: $mol_gap.text,
		},

		'[role="assistant_step"]': {
			Message_text_box: {
				flex: {
					shrink: 1,
					basis: 0,
				},
				height: '4.75rem',
				minHeight: 0,
				overflow: 'auto',
			},
			Message_text: {
				flex: {
					shrink: 0,
				},
			},
		},

		Thinking_status: {
			color: $mol_theme.shade,
		},

		Thinking_box: {
			position: 'relative',
			flex: {
				grow: 1,
				shrink: 1,
				basis: 0,
			},
			minHeight: 0,
			minWidth: 0,
			padding: {
				top: $mol_gap.block,
			},
		},

		Thinking_parts: {
			flex: {
				grow: 1,
				shrink: 1,
				basis: 0,
				direction: 'column',
			},
			width: '100%',
			height: '100%',
			minHeight: 0,
			overflow: 'auto',
			gap: $mol_gap.text,
		},

		Thinking_down: {
			position: 'absolute',
			right: $mol_gap.block,
			bottom: $mol_gap.block,
			zIndex: $mol_layer.hover,
		},

		Thinking_part_row: {
			flex: {
				shrink: 0,
			},
			padding: {
				left: $mol_gap.block,
				right: $mol_gap.block,
				top: $mol_gap.text,
				bottom: $mol_gap.block,
			},
			flexDirection: 'column',
			gap: $mol_gap.text,
		},

		Thinking_part_title: {
			color: $mol_theme.shade,
			font: {
				size: '0.8rem',
			},
		},

		Thinking_part_items: {
			flexDirection: 'column',
			gap: $mol_gap.text,
		},

		Thinking_text_row: {
			flex: {
				shrink: 0,
			},
			margin: '-0.75rem',
		},

		Thinking_plain_row: {
			flex: {
				shrink: 0,
			},
			whiteSpace: 'pre-wrap',
			overflowWrap: 'anywhere',
		},

	} )

}
